const SET_LANGUAGE = 'SET_LANGUAGE';

export const setLanguage = (lang) => {
  return {
    type: SET_LANGUAGE,
    lang
  };
};

const ACTION_HANDLERS = {
  [SET_LANGUAGE]: (state, action) => {
    console.log('SET_LANGUAGE --> ', action)
    return {
      ...state,
      lang: action.lang
    }
  }
};

// ------------------------------------
// Reducer
// ------------------------------------
const initialState = {
  // lang: 'zh'
  lang: localStorage.hasOwnProperty('lang') ? localStorage.getItem('lang') : 'zh'
}

export default function noticeReducer(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type];
  var result = handler ? handler(state, action) : state;

  return result;
}
